import moment from 'moment';
import { dateFormat } from '@/utils/date-format';

import { CargoHandlingCondition, PostureArms, PostureHands, PostureLoadCenter, PostureTwist, WorkConditionAdverse, WorkConditionClothes, WorkConditionHandsPosition, WorkConditionHoldLoad, WorkConditionSpatialCondition, WorkConditionTransfer, WorkOrganization } from '@/components/views/Report/KimLhc/enums';
import { KimLhcCategoryKey, RiskLevel } from '@/types';

import { lightTheme } from '@/styles/themes/light';

const { risk } = lightTheme.colors;

export const formatVideoInfoUploadDate = (upload_date: string | undefined) => {
    const formattedDate = dateFormat();
    if (!upload_date) return '';
	return moment(upload_date).format(formattedDate);
};

const RISK_LEVEL_COLORS: Record<RiskLevel, string> = {
	LOW: risk.low,
	SLIGHTLY_INCREASED: risk.moderate,
	SUBSTANTIALLY_INCREASED: risk.high,
	HIGH: risk.very_high
};

const DEFAULT_COLOR = risk.medium;

const CATEGORY_VALUE_TO_RISK_LEVEL: Record<string, Record<string, RiskLevel>> = {
	[KimLhcCategoryKey.CARGO_HANDLING_CONDITION]: {
		[CargoHandlingCondition.LOAD_HANDLED_WITH_BOTH_HANDS]: 'LOW',
		[CargoHandlingCondition.LOAD_HANDLED_WITH_TEMPORARILY_ONE_HAND]: 'SLIGHTLY_INCREASED',
		[CargoHandlingCondition.LOAD_HANDLED_WITH_ONE_HAND]: 'SUBSTANTIALLY_INCREASED'
	},
	[KimLhcCategoryKey.WORK_ORGANIZATION]: {
		[WorkOrganization.GOOD]: 'LOW',
		[WorkOrganization.RESTRICTED]: 'SLIGHTLY_INCREASED',
		[WorkOrganization.DESFAVORED]: 'SUBSTANTIALLY_INCREASED'
	},
	[KimLhcCategoryKey.WORK_CONDITION]: {
		[WorkConditionHandsPosition.HANDS_POSITION_OCCASIONAL]: 'SLIGHTLY_INCREASED',
		[WorkConditionHandsPosition.HANDS_POSITION_FREQUENT]: 'SUBSTANTIALLY_INCREASED',
		[WorkConditionTransfer.TRANSFER_OCCASIONAL]: 'SLIGHTLY_INCREASED',
		[WorkConditionTransfer.TRANSFER_FREQUENT]: 'SUBSTANTIALLY_INCREASED',
		[WorkConditionSpatialCondition.SPATIAL_CONDITION_RESTRICTED]: 'SUBSTANTIALLY_INCREASED',
		[WorkConditionSpatialCondition.SPATIAL_CONDITION_UNFAVOURABLE]: 'SUBSTANTIALLY_INCREASED',
		[WorkConditionAdverse.CLIMATICAL_CONDITIONS_UNFAVOURABLE]: 'SUBSTANTIALLY_INCREASED',
		[WorkConditionClothes.CLOTHES_ADDITIONAL_EFFORT]: 'SUBSTANTIALLY_INCREASED',
		[WorkConditionHoldLoad.HOLD_LOAD_DIFFICULT]: 'SLIGHTLY_INCREASED',
		[WorkConditionHoldLoad.HOLD_LOAD_SIGNIFICANT_DIFFICULTY]: 'SUBSTANTIALLY_INCREASED'
	},
	[KimLhcCategoryKey.POSTURE]: {
		[PostureTwist.TWIST_OCCASIONAL_TRUNK]: 'SLIGHTLY_INCREASED',
		[PostureTwist.TWIST_FREQUENT_TRUNK]: 'SUBSTANTIALLY_INCREASED',
		[PostureLoadCenter.LOAD_CENTER_OCCASIONAL]: 'SLIGHTLY_INCREASED',
		[PostureLoadCenter.LOAD_CENTER_FREQUENT]: 'SUBSTANTIALLY_INCREASED',
		[PostureArms.ARMS_OCCASIONAL]: 'SLIGHTLY_INCREASED',
		[PostureArms.ARMS_FREQUENT]: 'SUBSTANTIALLY_INCREASED',
		[PostureHands.HANDS_OCCASIONAL]: 'SLIGHTLY_INCREASED',
		[PostureHands.HANDS_FREQUENT]: 'SUBSTANTIALLY_INCREASED'
	}
};

export const getWarningIconColor = (category: KimLhcCategoryKey, riskLevel: string): string => {
	const riskLevelKey = CATEGORY_VALUE_TO_RISK_LEVEL[category]?.[riskLevel];
	return RISK_LEVEL_COLORS[riskLevelKey] ?? DEFAULT_COLOR;
};
